<template>
  <div>
    <h2 class="balance">
      Бонусы
      <span class="data-rows-number">
                {{ formatMoney(this.projectBonuses / 100, this.region) }}
            </span>
    </h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import currency from '../mixins/currency'

export default {
  name: 'BalanceView',

  mixins: [
    currency,
  ],

  methods: {
    fetchBalance () {
      this.$store.dispatch('project/fetchBonuses', this.$route.params.id)
    },
  },

  computed: mapGetters({
    region: 'project/region',
    projectBonuses: 'project/bonuses',
  }),

  mounted () {
    this.fetchBalance()
  },
}
</script>

<style scoped>
.balance {
  margin-top: -8px;
  margin-left: 20px;
  font-size: 28px;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/BonusView.vue